module.exports = __webpack_public_path__ + "img/lpa_2.0148e72f.jpg";